<template>
  <div id="imageViewerComponent">
    <!-- Vue Bootstrap Modal for Image Preview -->
    <b-modal
      v-model="isModalOpen"
      centered
      hide-footer
      hide-header
      body-class="p-0"
      content-class="image-modal"
    >
      <button class="btn btn-light close-btn" @click="closeModal" v-show="showButton">✕</button>

      <!-- Image Display -->
      <div class="image-container">
        <img :src="modalImageUrl" alt="Image Preview" class="preview-img" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
      modalImageUrl: '',
      showButton: false,
    };
  },
  methods: {
    openModal(url) {
      this.modalImageUrl = url;
      this.isModalOpen = true;
      this.showButton = false;

      // Delay showing close button slightly
      setTimeout(() => {
        this.showButton = true;
      }, 350);
    },
    closeModal() {
      this.showButton = false;
      this.isModalOpen = false;
      this.modalImageUrl = '';
    },
  },
};
</script>

<style scoped>
/* Outer modal container */
.image-modal {
  background: rgba(0, 0, 0, 0.9);
  display: inline-block;
  border-radius: 8px;
  padding: 10px; /* 10px border space */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.6);
  max-width: 95vw; /* prevent overflow on small screens */
  max-height: 95vh;
  width: auto !important;
    background-color: #ffffff00;
    border: 0px;  
}

/* Center content */
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Fit image naturally but scale down if needed */
.preview-img {
  display: block;
  max-width: calc(95vw - 20px);
  max-height: calc(95vh - 20px);
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

/* Close button styling */
.close-btn {
  position: fixed;
  top: 20px;
  right: 60px;
  z-index: 10;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  background: rgb(39 39 39 / 96%);
  border: none;
  border-radius: 63%;
  width: 38px;
  height: 36px;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.5s ease;
}

/* When v-show makes it visible */
.close-btn[v-cloak],
.close-btn[v-show="true"] {
  opacity: 1;
}
</style>
